import FlightRulesLinkModule from './../../flight-rules-link/flight-rules-link-module';

import FlightFare from './flight-fare-component';
import FlightFareService from './flight-fare-service';

import './flight-fare.scss';

const MODULE_NAME = 'app.flight.fare';
const module = angular.module(MODULE_NAME, [
        FlightRulesLinkModule,
    ])
    .directive(FlightFare.DIRECTIVE_NAME, FlightFare)
    .service('flightFareService', FlightFareService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-fare/flight-fare-module.js